import { render, staticRenderFns } from "./yingxiang.vue?vue&type=template&id=b04407fa&"
import script from "./yingxiang.vue?vue&type=script&lang=ts&"
export * from "./yingxiang.vue?vue&type=script&lang=ts&"
import style0 from "./yingxiang.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports